import React, { memo, useState } from 'react';

import Input from 'components/shared/Input/Input';

const IncrementCellEditor = memo((params) => {
  const { value, onValueChange } = params || {};
  const [inputValue, setInputValue] = useState(value);

  const handleChange = (event) => {
    const { value } = event.target;
    setInputValue(value);
    if (onValueChange) {
      onValueChange(value);
    }
  };
  return (
    <div tabIndex={1}>
      <Input
        type="number"
        inputWrapperClassName="h-[39px] border-none !bg-transparent"
        value={inputValue}
        onChange={handleChange}
      />
    </div>
  );
});

IncrementCellEditor.displayName = 'IncrementCellEditor';

export default IncrementCellEditor;
